import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getArtistOfMonth } from '../redux/ArtistOfMonthSlice';
import Pagination from '../components/Pagination';
import { useSearchExport } from '../context/SearchExportContext';
import '../styles/spinner/spinner.css';
import ExportDropdown from '../context/ExportDropdown';
import RecordsLoader from '../components/RecordsLoader';

const ArtistOfTheMonth = () => {
    const dispatch = useDispatch();
    const { monthArtist = [], status } = useSelector((state) => state.monthArtist); // Ensure monthArtist has a default value of an empty array
    const { filterData } = useSearchExport();
    const [currentPage, setCurrentPage] = useState(1);
    const monthArtistPerPage = 12;

    useEffect(() => {
        // Dispatch to fetch artist data
        dispatch(getArtistOfMonth());
    }, [dispatch]);

    const currentMonthArtist = monthArtist.length > 0
        ? filterData(monthArtist).slice(
            (currentPage - 1) * monthArtistPerPage,
            currentPage * monthArtistPerPage
        )
        : [];

    const redirectToProfile = (userId) => {
        window.location.href = `https://opencallforartists.com/users/user/${userId}`;
    };

    if (status === 'idle' || status === 'loading') {
        return <RecordsLoader text="Loading monthArtist, please hold on..." />;
    }

    if (status === 'failed') {
        return <p className="text-red-500">Error loading monthArtist.</p>;
    }

    return (
        <div className="container mx-auto p-6">
            <h1 className="text-2xl text-black font-bold mb-6">monthArtist List</h1>

            {/* Export Buttons */}
            <ExportDropdown data={monthArtist} fileName="monthArtist" />

            {/* Open Call List Table */}
            {monthArtist.length > 0 ? (
                <>
                    <table className="min-w-full table-auto bg-white shadow-md rounded-lg">
                        <thead>
                            <tr className="bg-gray-100 text-left">
                                <th className="px-4 py-2">ID</th>
                                <th className="px-4 py-2">Month</th>
                                <th className="px-4 py-2">Year</th>
                                <th className="px-4 py-2">Artist Name</th>
                                <th className="px-4 py-2">Email</th>
                                <th className="px-4 py-2">User Country</th>
                                <th className="px-4 py-2">Profile</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentMonthArtist.map((artist) => (
                                <tr
                                    key={artist.id}
                                    className="border-b cursor-pointer hover:bg-gray-100"
                                >
                                    <td className="px-4 py-2">{artist.id}</td>
                                    <td className="px-4 py-2">
                                        {new Date(0, artist.month - 1).toLocaleString('en-US', { month: 'long' })}
                                    </td>
                                    <td className="px-4 py-2">{artist.year}</td>
                                    <td className="px-4 py-2">{artist.user_first_name} {artist.user_last_name}</td>
                                    <td className="px-4 py-2">{artist.user_email}</td>
                                    <td className="px-4 py-2">{artist.user_country ? artist.user_country : "Not Available"}</td>
                                    <button
                                        onClick={() => redirectToProfile(artist.user_id)}
                                        className={`w-24 h-8 items-center justify-center px-2 py-1 rounded bg-blue-500 text-white`}>
                                        View
                                    </button>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/* Pagination */}
                    {monthArtist.length > monthArtistPerPage && (
                        <Pagination
                            usersPerPage={monthArtistPerPage}
                            totalUsers={monthArtist.length}
                            paginate={setCurrentPage}
                            currentPage={currentPage}
                        />
                    )}
                </>
            ) : (
                <p className="text-center text-gray-500">No monthArtist Found!</p>
            )}
        </div>
    );
};

export default ArtistOfTheMonth;